export default "/static/media/icon-newsletter.79f8289d.svg";